/**
 * True inside the Tauri desktop webview. `client/src` cannot import
 * `desktop/viewer/src/tauri.ts`'s own `isTauri()` -- the `@client` alias only runs
 * desktop -> client, never the other way. This is the one shared copy of that same
 * `window.__TAURI__` check; every Tauri-gated client/src module imports it instead of
 * repeating the two-line check (see `nativeAuthTauri.ts`, `nativeApiOriginTauri.ts`,
 * and `App.tsx`'s `isStandaloneRoute`).
 */
export function isTauri(): boolean {
    return typeof window !== "undefined" &&
        (window as unknown as { __TAURI__?: unknown }).__TAURI__ != null;
}
